__turbopack_context__.v({
  "container": "c160mq_container",
  "count": "c160mq_count",
  "description": "c160mq_description",
  "loading": "c160mq_loading",
  "number": "c160mq_number",
  "shimmer": "c160mq_shimmer",
});
